define('plugin/google-reviews/collection/GoogleReviewsCollection',['require','lib/collection/BaseCollection','plugin/google-reviews/model/GoogleReviewsModel','lib/model/BaseModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var GoogleReviewsModel = require('plugin/google-reviews/model/GoogleReviewsModel');
    var BaseModel = require('lib/model/BaseModel');

    /**
     * Google reviews collection
     *
     * @class GoogleReviewsCollection
     */
    return BaseCollection.extend({

        url: '/ext/google-reviews/',
        model: GoogleReviewsModel,
        _metaModel : null,

        initialize: function () {
            BaseCollection.prototype.initialize.apply(this, arguments);
            this._metaModel = new BaseModel();
        },

        meta: function(prop, value) {
            if (value === undefined) {
                return this._metaModel.get(prop);
            } else {
                this._metaModel.set(prop, value);
            }
        },

        getMetaModel : function() {
            return this._metaModel;
        },

        parse: function (response) {
            var _this = this;
            var result = BaseCollection.prototype.parse.apply(this, arguments);
            var reviews = (result && result.reviews) ? result.reviews : [];
            delete result.reviews;
            this._metaModel.set(result);
            this._metaModel.trigger('sync');
            return reviews;
        }

    });

});
